import { render } from "./ReturnCard.vue?vue&type=template&id=2215c928&scoped=true&ts=true"
import script from "./ReturnCard.vue?vue&type=script&lang=ts"
export * from "./ReturnCard.vue?vue&type=script&lang=ts"

import "./ReturnCard.vue?vue&type=style&index=0&id=2215c928&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/funds_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2215c928"]])

export default __exports__